import image0 from "./0.jpg";
import image1 from "./1.jpg";

export default [image0, image1];
